import React, { useState, useCallback } from 'react';
import Header from './Header';
import MobileDrawer from './MobileDrawer';
import Footer from './Footer';

export default function Layout({ children }) {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const closeDrawer = useCallback(() => setDrawerOpen(false), []);
  return (
    <div className="site">
      <a className="skip-link" href="#main">Skip to content</a>
      <Header onOpenDrawer={() => setDrawerOpen(true)} />
      <MobileDrawer open={drawerOpen} onClose={closeDrawer} />
      <main id="main" className="site__main">{children}</main>
      <Footer />
    </div>
  );
}
